import API from "./axios";

const hundekariLedgerApi = {
  getSummary:      ()                       => API.get("/hundekari-ledger/summaries"),
  getLedger:       (hundekariId)            => API.get(`/hundekari-ledger/${hundekariId}`),
  getLedgerRange:  (hundekariId, from, to)  => API.get(`/hundekari-ledger/${hundekariId}/range?from=${from}&to=${to}`),
  exportPdf:       (hundekariId, from, to)  => API.get(`/hundekari-ledger/${hundekariId}/pdf?from=${from}&to=${to}`, { responseType: "blob" }),
  deletePayment:   (ledgerId)               => API.delete(`/hundekari-ledger/entry/${ledgerId}`),
  recordPayment:   (data)                   => API.post(`/hundekari-ledger/${data.hundekariId}/payment`, {
    amount: data.amount,
    paymentDate: data.date,
    paymentMode: data.paymentMode,
    paymentReference: data.paymentReference,
    notes: data.notes,
  }),
};

export default hundekariLedgerApi;